import React, { useState } from "react";
import {
  Row,
  Col,
  Button,
  Input,
  Modal,
  Form,
  Select,
  DatePicker,
  Switch,
} from "antd";
import { Scrollbars } from "react-custom-scrollbars";
import closeX from "../../../../assets/images/close-x.svg";
import data from "../../../../constants/retailPos.json";

const { Option } = Select;

/**
 * Legacy Modal UI for editing/viewing a customer using the old Contact/Details toggle.
 * Shown when `retailCustomerFields` is empty (legacy config).
 */
const LegacyEditCustomerModal = ({
  form,
  displayEditOldCustomer,
  editFlag,
  editOldCustomer,
  closeCustomerSearch,
  setDisplayEditOldCustomer,
  setEditFlag,
  cart,
  selectedEditOldCustomer,
  loyalityType,
  enableLoyality,
  onSwitchChange,
  renderThumb,
  renderThumbHorizontalScroll,
  posConfig,
  open,
  showVirtualKeyboard,
  keyboardInputFields,
  setKeyboardInputFields,
  keyboard,
  setOpen,
  setInputName,
  inputName,
  editCustomer,
}) => {
  const [toggleCustomer, setToggleCustomer] = useState(false);

  const onFocusInput = (fieldName) => {
    setInputName(fieldName);
    setOpen(true);
    setTimeout(() => {
      const currentInputValue = keyboardInputFields[fieldName] || "";
      keyboard?.current?.setInput(currentInputValue);
    }, 300);
  };

  const onChangeInput = (event) => {
    const inputVal = event.target.value;
    setKeyboardInputFields({ ...keyboardInputFields, [inputName]: inputVal });
    keyboard?.current?.setInput(inputVal);
  };

  const getInputValue = (name) => keyboardInputFields[name] || "";

  const closeHandler = () => {
    form.resetFields();
    closeCustomerSearch();
    setDisplayEditOldCustomer(false);
    setEditFlag(false);
    setToggleCustomer(false);
  };

  return (
    <>
      <Row style={{ fontSize: "1vw", marginTop: "1.5vh" }}>
        <Col span={24}>
          {displayEditOldCustomer && editFlag ? (
            <span style={data.posScreenStyles.addEditCustomerModal.addNewCustLabel}>Edit Customer</span>
          ) : (
            <span style={data.posScreenStyles.addEditCustomerModal.addNewCustLabel}>View Customer</span>
          )}
          <img
            onClick={closeHandler}
            style={{ float: "right", cursor: "pointer", width: "1.5vw", marginLeft: "1vw" }}
            src={closeX}
            alt=""
          />
        </Col>
      </Row>

      <Row
        style={{
          backgroundColor: "#f5f5f5",
          padding: "6px",
          borderRadius: "8px",
          marginTop: "2vh",
          height: "7vh",
          display: "flex",
        }}
      >
        <Col
          onClick={() => setToggleCustomer(false)}
          style={{
            flex: 1,
            padding: "6px 0",
            borderRadius: "6px",
            backgroundColor: !toggleCustomer ? "#fff" : "transparent",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: !toggleCustomer ? "#000" : "#8c8c8c",
            fontWeight: !toggleCustomer ? 600 : 500,
            boxShadow: !toggleCustomer ? "0px 0px 4px rgba(0,0,0,0.05)" : "none",
            transition: "all 0.2s ease",
          }}
        >
          Contact
        </Col>
        <Col
          onClick={() => setToggleCustomer(true)}
          style={{
            flex: 1,
            padding: "6px 0",
            borderRadius: "6px",
            backgroundColor: toggleCustomer ? "#fff" : "transparent",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: toggleCustomer ? "#000" : "#8c8c8c",
            fontWeight: toggleCustomer ? 600 : 500,
            boxShadow: toggleCustomer ? "0px 0px 4px rgba(0,0,0,0.05)" : "none",
            transition: "all 0.2s ease",
          }}
        >
          Details
        </Col>
      </Row>

      {displayEditOldCustomer && editFlag ? (
        <Form key={"editCustomer"} form={form} name="editCustomer">
          <Scrollbars
            thumbSize={100}
            renderThumbHorizontal={renderThumbHorizontalScroll}
            renderThumbVertical={renderThumb}
            style={{ height: open && showVirtualKeyboard ? "20vh" : "72vh" }}
          >
            <div style={{ display: toggleCustomer ? "block" : "none", overflowX: "hidden" }}>
              <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.35)", marginTop: "2.5vh", width: "80.5vw", fontSize: "1vw" }}>
                <Col span={24}>
                  <label style={{ fontSize: "1em", fontWeight: 500, letterSpacing: "1.5px", color: "#0F0718" }}>MAILING ADDRESS</label>
                </Col>
              </Row>
              <Row style={{ fontSize: "1vw" }}>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Street</label>
                  <Form.Item name="street" onFocus={() => onFocusInput("street")} id="sm-product-search" value={getInputValue("street")} onChange={onChangeInput} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Input className="customerDetailsInput" placeholder="Street" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>City</label>
                  <Form.Item name="city" onFocus={() => onFocusInput("city")} id="sm-product-search" value={getInputValue("city")} onChange={onChangeInput} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Input className="customerDetailsInput" placeholder="City" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>State</label>
                  <Form.Item name="state" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Input readOnly onFocus={() => onFocusInput("state")} id="sm-product-search" value={getInputValue("state")} onChange={onChangeInput} className="customerDetailsInput" placeholder="Enter State" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Country</label>
                  <Form.Item name="country" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Input readOnly onFocus={() => onFocusInput("country")} id="sm-product-search" value={getInputValue("country")} onChange={onChangeInput} className="customerDetailsInput" placeholder="Enter Country" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Pincode</label>
                  <Form.Item name="pincode" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Input onFocus={() => onFocusInput("pincode")} id="sm-product-search" value={getInputValue("pincode")} onChange={onChangeInput} className="customerDetailsInput" placeholder="Enter Pincode" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                  </Form.Item>
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)", marginBottom: "1vh", marginTop: "3vh", width: "80.5vw", fontSize: "1vw" }}>
                <Col span={24}>
                  <label style={{ fontSize: "1em", fontWeight: 500, letterSpacing: "1.5px", color: "#0F0718" }}>LOYALTY</label>
                </Col>
              </Row>
              <Row style={{ fontSize: "1vw" }}>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2.5vh" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Loyalty</label>
                  <Form.Item name="loyality" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Switch onChange={onSwitchChange} defaultChecked />
                    &nbsp; <span style={{ fontFamily: "Inter", fontSize: "1em", fontWeight: 500, color: "#0F0718" }}>Enable loyalty for this customer</span>
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Program</label>
                  {enableLoyality && (
                    <Form.Item name="program" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Select disabled={true} style={{ width: "27.5vw", height: "7vh" }}>
                        <Option key={loyalityType[0]?.loyaltylevelId} value={loyalityType[0]?.loyaltylevelId}>{loyalityType[0]?.name}</Option>
                      </Select>
                    </Form.Item>
                  )}
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)", marginBottom: "1.5vh", width: "80.5vw", fontSize: "1vw" }}>
                <Col span={24}>
                  <label style={{ fontSize: "1em", fontWeight: 500, letterSpacing: "1.5px", color: "#0F0718" }}>GENERAL INFORMATION</label>
                </Col>
              </Row>
              <Row>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh", fontSize: "1vw" }}>
                  <label style={{ fontSize: "1.1em", color: "#0F0718", fontWeight: "500" }}>Anniversary Date</label>
                  <Form.Item name="anniversaryDate" style={{ border: "0", margin: "7px 0" }}>
                    <DatePicker placeholder="DD/MM/YYYY" className="cutomerDobInput" format="DD/MM/YYYY" style={{ height: "7.5vh", border: "1px solid #d9d9d9", width: "95%" }} />
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh", fontSize: "1vw" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Tax ID</label>
                  <Form.Item name="taxID" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Input onFocus={() => onFocusInput("taxID")} id="sm-product-search" value={getInputValue("taxID")} onChange={onChangeInput} className="customerDetailsInput" placeholder="Tax ID" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ fontSize: "1vw" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Date of Birth</label>
                  <Form.Item name="birthday" style={{ border: "0", margin: "7px 0" }}>
                    <DatePicker placeholder="DD/MM/YYYY" className="cutomerDobInput" format="DD/MM/YYYY" style={{ height: "7.5vh", border: "1px solid #d9d9d9", width: "96.5%" }} />
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ fontSize: "1vw" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Gender</label>
                  <Form.Item name="gender" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Select size="large" style={{ border: "1px solid #d9d9d9", width: "28vw" }} className="genderSelect">
                      <Option key={"MAL"} value="MAL">Male</Option>
                      <Option key={"FEM"} value="FEM">Female</Option>
                      <Option key={"TRA"} value="TRA">Transgender</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <div style={{ overflowX: "hidden" }}>
                <Row>
                  <p style={{ fontSize: "1.1em", margin: 0, fontWeight: "600", color: "#0F0718", paddingBottom: "1vh" }}>Additional Information</p>
                  <div style={{ backgroundColor: "#fff", width: "80.7vw", fontSize: "1vw" }}>
                    <Col span={24}>
                      <Row style={{ padding: "3px 0" }}>
                        <Col span={12} className="addtInfo">Last Visit Date</Col>
                        <Col span={2}>:</Col>
                        <Col span={9} offset={1} className="addtInfo">{cart?.customer?.lastVisitDate ? cart?.customer?.lastVisitDate || "0" : selectedEditOldCustomer?.lastVisitDate || "0"}</Col>
                      </Row>
                      <Row style={{ padding: "3px 0" }}>
                        <Col span={12} className="addtInfo">No Of Visits</Col>
                        <Col span={2}>:</Col>
                        <Col span={9} offset={1} className="addtInfo">{cart?.customer?.noOfVisits ? cart?.customer?.noOfVisits || "0" : selectedEditOldCustomer?.noOfVisits || "0"}</Col>
                      </Row>
                      <Row style={{ padding: "3px 0" }}>
                        <Col span={12} className="addtInfo">Last Billing Amount</Col>
                        <Col span={2}>:</Col>
                        <Col span={9} offset={1} className="addtInfo">{cart?.customer?.lastBillingAmount ? cart?.customer?.lastBillingAmount || "0" : selectedEditOldCustomer?.lastBillingAmount || "0"}</Col>
                      </Row>
                      <Row style={{ padding: "3px 0" }}>
                        <Col span={12} className="addtInfo">Average Basket Value</Col>
                        <Col span={2}>:</Col>
                        <Col span={9} offset={1} className="addtInfo">{cart?.customer?.averageBasketValue ? cart?.customer?.averageBasketValue || "0" : selectedEditOldCustomer?.averageBasketValue || "0"}</Col>
                      </Row>
                      <Row style={{ padding: "3px 0" }}>
                        <Col span={12} className="addtInfo">Loyalty Balance Points</Col>
                        <Col span={2}>:</Col>
                        <Col span={9} offset={1} className="addtInfo">{cart?.customer?.retlLoyaltyBalance ? cart?.customer?.retlLoyaltyBalance.toFixed(2) || " " : selectedEditOldCustomer?.retlLoyaltyBalance || " "}</Col>
                      </Row>
                      <Row style={{ padding: "3px 0" }}>
                        <Col span={12} className="addtInfo">Credit Balance</Col>
                        <Col span={2}>:</Col>
                        <Col span={9} offset={1} className="addtInfo">{cart?.customer?.creditLimit ? cart?.customer?.creditLimit || " " : selectedEditOldCustomer?.creditLimit || " "}</Col>
                      </Row>
                    </Col>
                  </div>
                </Row>
              </div>
            </div>
            <div style={{ display: toggleCustomer ? "none" : "block", fontSize: "1vw", marginTop: "2vh", overflow: "hidden" }}>
              <Row>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>First Name</label>
                  <Form.Item name="editName" rules={[{ required: true, message: "Please Input Name" }]} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Input className="customerDetailsInput" onFocus={() => onFocusInput("editName")} id="sm-product-search" value={getInputValue("editName")} onChange={onChangeInput} placeholder="Enter Name" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Last Name</label>
                  <Form.Item name="lastName" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Input className="customerDetailsInput" onFocus={() => onFocusInput("lastName")} id="sm-product-search" value={getInputValue("lastName")} onChange={onChangeInput} placeholder="Enter Last Name" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Email</label>
                  <Form.Item name="editEmail" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Input className="customerDetailsInput" onFocus={() => onFocusInput("editEmail")} id="sm-product-search" value={getInputValue("editEmail")} onChange={onChangeInput} placeholder="Enter Email" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Contact Number</label>
                  <Form.Item
                    name="editMobile"
                    rules={[
                      { required: true, message: "Mobile number is required" },
                      { pattern: new RegExp(/^[0-9]+$/), message: "Only digits are allowed" },
                      {
                        validator: (_, value) => {
                          const lengthRaw = posConfig?.customerMobileNumberLength;
                          const lengthRequired = Number(lengthRaw);
                          const isLengthValidNumber = !isNaN(lengthRequired) && Number.isInteger(lengthRequired) && lengthRequired > 0;
                          if (!value) return Promise.reject("Mobile number is required");
                          if (!/^[0-9]+$/.test(value)) return Promise.reject("Only digits are allowed");
                          if (isLengthValidNumber && value.length !== lengthRequired) return Promise.reject(`Mobile number must be exactly ${lengthRequired} digits`);
                          return Promise.resolve();
                        },
                      },
                    ]}
                    style={data.posScreenStyles.addEditCustomerModal.formItem}
                  >
                    <Input
                      type="text"
                      value={getInputValue("editMobile")}
                      onChange={(event) => {
                        const inputVal = event.target.value.replace(/\D/g, "");
                        const lengthRaw = posConfig?.customerMobileNumberLength;
                        const maxLen = Number(lengthRaw);
                        const isLengthValidNumber = !isNaN(maxLen) && Number.isInteger(maxLen) && maxLen > 0;
                        if (!isLengthValidNumber || inputVal.length <= maxLen) {
                          setKeyboardInputFields({ ...keyboardInputFields, editMobile: inputVal });
                          keyboard?.current?.setInput(inputVal);
                          form.setFieldsValue({ editMobile: inputVal });
                        }
                      }}
                      onFocus={() => onFocusInput("editMobile")}
                      onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) event.preventDefault(); }}
                      id="sm-product-search"
                      className="customerDetailsInput"
                      placeholder="Enter Contact Number"
                      style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                      maxLength={posConfig?.customerMobileNumberLength}
                    />
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Pincode</label>
                  <Form.Item name="editPincode" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Input className="customerDetailsInput" onFocus={() => onFocusInput("editPincode")} id="sm-product-search" value={getInputValue("editPincode")} onChange={onChangeInput} placeholder="Enter Pincode" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} />
                  </Form.Item>
                </Col>
              </Row>
            </div>
          </Scrollbars>
          <Row>
            <Col xs={{ span: 9 }} lg={{ span: 19 }} xl={{ span: 19 }} xxl={{ span: 19 }} />
            <Col xs={{ span: 14 }} lg={{ span: 4 }} xl={{ span: 4 }} xxl={{ span: 4 }}>
              <Form.Item style={{ paddingTop: "3vh", fontSize: "1vw" }}>
                <Button className="customerDetailsSubmitBtnBtn" style={data.posScreenStyles.addEditCustomerModal.customerDetailsSubmitBtn} onClick={editCustomer}>
                  Save & Proceed
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      ) : toggleCustomer ? (
        <Form key={"editCustomer"} form={form} name="editCustomer">
          <Scrollbars thumbSize={100} renderThumbHorizontal={renderThumbHorizontalScroll} renderThumbVertical={renderThumb} style={{ height: open && showVirtualKeyboard ? "20vh" : "71vh" }}>
            <div style={{ display: toggleCustomer ? "block" : "none", fontSize: "1vw", overflowX: "hidden" }}>
              <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.35)", marginTop: "1.5vh", fontSize: "1vw" }}>
                <Col span={24}>
                  <label style={{ fontSize: "1em", fontWeight: 500, letterSpacing: "1.5px", color: "#0F0718" }}>MAILING ADDRESS</label>
                </Col>
              </Row>
              <Row>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Street</label>
                  <Form.Item name="street" disabled={true} rules={[{ required: true, message: "Please Input Street" }]} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Input disabled={true} className="customerDetailsInput" placeholder="Street" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} value={selectedEditOldCustomer ? selectedEditOldCustomer?.customerAddress?.line1 : cart?.customer?.customerAddress?.line1} />
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>City</label>
                  <Form.Item name="city" disabled={true} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Input disabled={true} className="customerDetailsInput" placeholder="City" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} value={selectedEditOldCustomer ? selectedEditOldCustomer?.customerAddress?.city : cart?.customer?.customerAddress?.city} readOnly />
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>State</label>
                  <Form.Item name="state" disabled={true} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Input disabled={true} className="customerDetailsInput" placeholder="Enter State" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} value={selectedEditOldCustomer ? selectedEditOldCustomer?.customerAddress?.line2 : cart?.customer?.customerAddress?.region} readOnly />
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Country</label>
                  <Form.Item name="country" disabled={true} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Input disabled={true} className="customerDetailsInput" placeholder="Enter Country" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} value={selectedEditOldCustomer ? selectedEditOldCustomer?.customerAddress?.country : cart?.customer?.customerAddress?.country} readOnly />
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Pincode</label>
                  <Form.Item name="pincode" disabled={true} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Input disabled={true} className="customerDetailsInput" placeholder="Enter Pincode" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} value={selectedEditOldCustomer ? selectedEditOldCustomer?.pincode : cart?.customer?.pincode} readOnly />
                  </Form.Item>
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)", marginBottom: "1.5vh", marginTop: "1vh", width: "80.5vw" }}>
                <Col span={24}>
                  <label style={{ fontSize: "1em", fontWeight: 500, letterSpacing: "1.5px", color: "#0F0718" }}>LOYALTY</label>
                </Col>
              </Row>
              <Row>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2.5vh" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Loyalty</label>
                  <Form.Item name="loyality" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Switch onChange={onSwitchChange} defaultChecked />
                    &nbsp; <span style={{ fontFamily: "Inter", fontSize: "1em", fontWeight: 500, color: "#0F0718" }}>Enable loyalty for this customer</span>
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2.5vh" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Program</label>
                  {enableLoyality && (
                    <Form.Item name="program" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                      <Select disabled={true} style={{ width: "27.5vw", height: "7vh" }}>
                        <Option key={loyalityType[0]?.loyaltylevelId} value={loyalityType[0]?.loyaltylevelId}>{loyalityType[0]?.name}</Option>
                      </Select>
                    </Form.Item>
                  )}
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)", marginBottom: "1.5vh", width: "80.5vw" }}>
                <Col span={24}>
                  <label style={{ fontSize: "1em", fontWeight: 500, letterSpacing: "1.5px", color: "#0F0718" }}>GENERAL INFORMATION</label>
                </Col>
              </Row>
              <Row>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Anniversary Date</label>
                  <Form.Item name="anniversaryDate" disabled={true} style={{ border: "0" }}>
                    <DatePicker disabled={true} placeholder="DD/MM/YYYY" className="cutomerDobInput" format="DD/MM/YYYY" style={{ height: "7.3vh", border: "none", marginTop: 10, width: "95%" }} />
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Tax ID</label>
                  <Form.Item disabled={true} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Input disabled={true} className="customerDetailsInput" placeholder="Tax ID" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} value={selectedEditOldCustomer ? selectedEditOldCustomer?.taxId : cart?.customer?.taxId} readOnly />
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Birthday</label>
                  <Form.Item name="birthday" disabled={true} style={{ border: "0", margin: "7px 0" }}>
                    <DatePicker disabled={true} placeholder="DD/MM/YYYY" className="cutomerDobInput" format="DD/MM/YYYY" />
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Gender</label>
                  <Form.Item name="gender" disabled={true} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Select size="large" className="genderSelect">
                      <Option key={"MAL"} value="MAL">Male</Option>
                      <Option key={"FEM"} value="FEM">Female</Option>
                      <Option key={"TRA"} value="TRA">Transgender</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <div>
                <Row>
                  <p style={{ fontSize: "1.1em", margin: 0, fontWeight: "600", color: "#0F0718" }}>Additional Information</p>
                  <div style={{ backgroundColor: "#fff", width: "80.6vw", fontSize: "1vw", marginTop: "1vh" }}>
                    <Col span={24}>
                      <Row style={{ padding: "3px 0", fontSize: "1vw" }}>
                        <Col span={12} className="addtInfo">Last Visit Date</Col>
                        <Col span={2}>:</Col>
                        <Col span={9} offset={1} className="addtInfo">{selectedEditOldCustomer ? selectedEditOldCustomer.lastVisitDate : cart?.customer?.lastVisitDate}</Col>
                      </Row>
                      <Row style={{ padding: "3px 0", fontSize: "1vw" }}>
                        <Col span={12} className="addtInfo">No Of Visits</Col>
                        <Col span={2}>:</Col>
                        <Col span={9} offset={1} className="addtInfo">{selectedEditOldCustomer ? selectedEditOldCustomer.noOfVisits : cart?.customer?.noOfVisits}</Col>
                      </Row>
                      <Row style={{ padding: "3px 0", fontSize: "1vw" }}>
                        <Col span={12} className="addtInfo">Last Billing Amount</Col>
                        <Col span={2}>:</Col>
                        <Col span={9} offset={1} className="addtInfo">{selectedEditOldCustomer ? selectedEditOldCustomer.lastBillingAmount : cart?.customer?.lastBillingAmount}</Col>
                      </Row>
                      <Row style={{ padding: "3px 0", fontSize: "1vw" }}>
                        <Col span={12} className="addtInfo">Average Basket Value</Col>
                        <Col span={2}>:</Col>
                        <Col span={9} offset={1} className="addtInfo">{selectedEditOldCustomer ? selectedEditOldCustomer.averageBasketValue : cart?.customer?.averageBasketValue}</Col>
                      </Row>
                      <Row style={{ padding: "3px 0", fontSize: "1vw" }}>
                        <Col span={12} className="addtInfo">Loyalty Balance Points</Col>
                        <Col span={2}>:</Col>
                        <Col span={9} offset={1} className="addtInfo">{cart?.customer?.retlLoyaltyBalance ? cart?.customer?.retlLoyaltyBalance || " " : selectedEditOldCustomer?.retlLoyaltyBalance || " "}</Col>
                      </Row>
                      <Row style={{ padding: "3px 0", fontSize: "1vw" }}>
                        <Col span={12} className="addtInfo">Credit Balance</Col>
                        <Col span={2}>:</Col>
                        <Col span={9} offset={1} className="addtInfo">{cart?.customer?.creditLimit ? cart?.customer?.creditLimit || " " : cart?.customer?.creditLimit || " "}</Col>
                      </Row>
                    </Col>
                  </div>
                </Row>
              </div>
            </div>
          </Scrollbars>
        </Form>
      ) : (
        <Form key={"viewCustomer"} form={form} name="viewForm">
          <Scrollbars thumbSize={100} renderThumbHorizontal={renderThumbHorizontalScroll} renderThumbVertical={renderThumb} style={{ height: open && showVirtualKeyboard ? "20vh" : "61vh" }}>
            <div style={{ overflow: "hidden" }}>
              <Row>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2.5vh", fontSize: "1vw" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>First Name</label>
                  <Form.Item disabled={true} name="editName" rules={[{ message: "Please Input Name" }]} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Input disabled={true} className="customerDetailsInput" placeholder="Enter Name" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} value={selectedEditOldCustomer ? selectedEditOldCustomer?.name : cart?.customer?.name} readOnly />
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2.5vh", fontSize: "1vw" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Last Name</label>
                  <Form.Item disabled={true} name="lastName" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Input disabled={true} className="customerDetailsInput" placeholder="Enter Last Name" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} value={cart?.customer?.lastName ? cart?.customer?.lastName : selectedEditOldCustomer?.lastName} readOnly />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh", fontSize: "1vw" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Email</label>
                  <Form.Item disabled={true} name="editEmail" rules={[{ required: false, pattern: new RegExp(/\S+@\S+\.\S+/), message: "Please Input Valid Email" }]} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Input disabled={true} className="customerDetailsInput" placeholder="Enter Email" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} value={""} readOnly />
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh", fontSize: "1vw" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Contact Number</label>
                  <Form.Item disabled={true} name="editMobile" rules={[{ required: false, pattern: new RegExp(/^[6-9][0-9]{9}$/), message: "Please Input Mobile" }]} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Input disabled={true} className="customerDetailsInput" placeholder="Enter Contact Number" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} value={selectedEditOldCustomer ? selectedEditOldCustomer?.mobileNo : cart?.customer?.mobileNo} readOnly />
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh", fontSize: "1vw" }}>
                  <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Pincode</label>
                  <Form.Item disabled={true} name="editPincode" rules={[{ required: false, pattern: new RegExp(/\d+/g), message: "Please Input Pincode" }]} style={data.posScreenStyles.addEditCustomerModal.formItem}>
                    <Input disabled={true} className="customerDetailsInput" placeholder="Enter Pincode" style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput} value={selectedEditOldCustomer ? selectedEditOldCustomer?.pincode : cart?.customer?.pincode} readOnly />
                  </Form.Item>
                </Col>
              </Row>
            </div>
          </Scrollbars>
        </Form>
      )}
    </>
  );
};

export default LegacyEditCustomerModal;
